import React from 'react';

import ConsignBanner from './ConsignBanner';
import ConsignForm from './ConsignForm';
import { NewsDetailConsignProps } from './props';
import { ConsignWrapper, FooterBorderReset } from './styles';
import UnderstandConsignment from './UnderstandConsignment';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const NewsDetailConsign: React.FC<NewsDetailConsignProps> = (props) => {
  const { webView, locationState } = props;

  // ======================= HOOKS

  // ======================= STATE

  // ======================= EFFECTS

  // ======================= VARIABLES

  // ======================= VIEWS
  return (
    <ConsignWrapper>
      <FooterBorderReset />
      <ConsignBanner webView={webView} />
      <ConsignForm webView={webView} locationState={locationState} />
      <UnderstandConsignment />
      {webView && (
        <div
          style={{ height: 60, width: '100%', backgroundColor: '#e9ecf3' }}
        />
      )}
    </ConsignWrapper>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export default NewsDetailConsign;
